import React from "react";
import TrainBetweenTurns from "../game-views/train_between_turns";

class TestSpinnerOption extends React.Component {
    gameInfo = null;
    _isMounted = false;
    constructor(props) {
        super(props);
        this.gameInfo = this.props.gameInfo();
        this.state={
           nextTurn: true,
           showAnimation: true,
        }
        this.trainVideoDone = this.trainVideoDone.bind(this);
        this.restartAnimation = this.restartAnimation.bind(this);
    }
    
render() {     
         this.prevMonth = "September 2021";
         this.currentMonth = "September 2029";       
         this.message = "4 Years Have Elapsed"
         this.gameBoardClass = 'card mt-3 mr-3 rounded-corners-lg text-center gameBoard'
         this.backgroundURL = './assets/homes/bg_photo.jpg'
         //this.backgroundURL = "./assets/homes/1br-option1/default.jpg"
return <>
    <div className="col-8">
        <div className={this.gameBoardClass}
                 style={{ backgroundImage: `url(${process.env.PUBLIC_URL + this.backgroundURL})` }}>
            <TrainBetweenTurns
                prevMonth={this.prevMonth}
                currentMonth={this.currentMonth}
                trainVideoDone={() => this.trainVideoDone()} 
            />
            <h4 className="text-center">{this.message}</h4>
        </div>
    </div>   

            
</>
}

trainVideoDone(){
    this.message = "Train Video Done"
    this.setState({nextTurn: false});
}

restartAnimation(){
     this.setState({nextTurn: true});
}

}


export default TestSpinnerOption;